module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/2023/link_icon/link_website-46772b5598dcfe0dd3ef694b7fedf4cf.svg&quot;;"